import { Component, inject, input } from '@angular/core';
import {BlockUI} from 'primeng/blockui';
import {ProgressSpinner} from 'primeng/progressspinner';
import {BlockDocumentUiState} from '../../state/block-document-ui.state';

@Component({
  selector: 'app-block-document-ui',
  imports: [BlockUI, ProgressSpinner],
  templateUrl: './block-document-ui.component.html',
  styleUrl: './block-document-ui.component.css',
})
export class BlockDocumentUiComponent {

  protected readonly state = inject(BlockDocumentUiState)

}
